export default "__VITE_ASSET__D8ffGYT4__"